angular.module("boyds").factory('confirmationService', function () {
    function confirmMessage(msg) {
        return confirm(msg);
    }
    return {
        confirmMessage: confirmMessage
    }
});